// extracted by mini-css-extract-plugin
export default {"container":"vq-z","heading":"wq-z","text":"xq-z","info":"yq-z","link":"zq-z","fullMaxWidth":"Aq-z"};